type localesKeys__Navigation = {
    techRadarNavItem__label: string;
    storybookNavItem__label: string;
    downloadNavItem__label: string;
    contactNavItem__label: string;
    myCvNavItem__label: string;
}

const ruLocale__Navigation: localesKeys__Navigation = {
    techRadarNavItem__label: 'Техн Радар',
    storybookNavItem__label: 'StoryBook',
    downloadNavItem__label: 'Скачать',
    contactNavItem__label: 'Контакт',
    myCvNavItem__label: 'Моё CV'
};

const enLocale__Navigation: localesKeys__Navigation = {
    techRadarNavItem__label: 'Tech Radar',
    storybookNavItem__label: 'StoryBook',
    downloadNavItem__label: 'Download',
    contactNavItem__label: 'Contact',
    myCvNavItem__label: 'My CV'
};

export { ruLocale__Navigation, enLocale__Navigation };
export type { localesKeys__Navigation };
